import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import { deleteUom, updateUom } from "../graphQL/graphMutation";

export const updateUomService = async (values, id) => {
  let updateStatus = false;
  let errormessage;
  try {
    const res = await request(BASEURL, updateUom, {
      id: id,
      ...values,
    });
    updateStatus = true;
  } catch (err) {
    console.error(err.message, "updateCustomerServive error");
    errormessage=err.response?.errors?.[0]?.message;
    updateStatus = false;
  }
  return  {updateStatus ,errormessage};
};

export const delteUomService = async (id) => {
  let delteStatus = false;
  try {
    const res = await request(BASEURL, deleteUom, { id: id });
    delteStatus = true;
  } catch (err) {
    console.error(err.message, "delteCustomerMutation error");
    delteStatus = false;
  }

  return delteStatus;
};
